import { render, staticRenderFns } from "./DotCircleIcon.vue?vue&type=template&id=32229b95&scoped=true"
import script from "./DotCircleIcon.vue?vue&type=script&lang=js"
export * from "./DotCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32229b95",
  null
  
)

export default component.exports